import React from "react";
import { formatPlayerName } from "../../utils/textUtils";
import {
  formatCareerStatValue,
  getCareerStatRawValue,
  getCompareCareerRows,
  getPlayerCompareSubtitle,
  getRowLeaderIndex,
  hasCareerStatsForCategory,
  isSelectedStatRow,
} from "../../utils/compareCareerStats";
import CompareCareerTable from "./CompareCareerTable";

const CompareHeadToHeadTable = ({
  playerSlots,
  statCategory,
  selectedStat,
  showComparison,
}) => {
  const activePlayers = playerSlots.filter(
    (slot) => slot.data && hasCareerStatsForCategory(slot.data, statCategory)
  );

  return (
    <CompareCareerTable
      playerSlots={activePlayers}
      sport="mlb"
      showComparison={showComparison}
      getName={formatPlayerName}
      getSubtitle={(data) => getPlayerCompareSubtitle(data, statCategory)}
      statRows={getCompareCareerRows(statCategory)}
      getRawValue={(data, row) =>
        getCareerStatRawValue(data.stats[statCategory]?.career, row)
      }
      formatValue={formatCareerStatValue}
      isHighlightedRow={(row) => isSelectedStatRow(row, selectedStat)}
      getLeaderIndex={(values, row) => getRowLeaderIndex(values, row.key)}
    />
  );
};

export default CompareHeadToHeadTable;
